import { Component, Watch, Vue } from 'vue-property-decorator'
import { lineChart } from '../../../../components/charts/index'
import { lineChartData, lineChartOptions } from './chartConfig'
import { mapState } from 'vuex';
import { ISession } from '../../../../types';

interface IRankings {
  domainName: string;
  keywordsDetails: {
    keyword: string;
    searshVolume: number;
    currentPlace: number;
    projectsStart: number;
    rankings: number[];
    dates: string[];
  }[];
  label: string;
}

@Component({
  components: {
    lineChart
  },
  computed: mapState({
    ServiceId: (state: { session: ISession }) => state.session.serviceId
  })
})

export default class Rankings extends Vue {

  private namespace: string = '/Keywords';

  private ServiceId!: number;

  private rankings: IRankings | null = null;

  private selectedKeyword: number = 0;

  private error: boolean = false;

  private get LineChartData () {

    if (this.rankings != null) {

      let chartData = {...lineChartData};

      const rankingsData = this.rankings.keywordsDetails[this.selectedKeyword].rankings.map(ranking =>
        ranking < 300 ? ranking : null); 
      
      chartData.labels = this.rankings.keywordsDetails[this.selectedKeyword].dates;
      chartData.datasets[0].label = this.rankings.domainName;
      chartData.datasets[0].data = rankingsData as number[];

      return chartData;
    }

    return lineChartData;
  }

  private get LineChartOptions () {

    if (this.rankings != null) {

      let chartOptions = {...lineChartOptions};

      chartOptions.scales.yAxes[0].scaleLabel.labelString = this.$t('keywords.rankings.title') as string;

      return chartOptions;
    }

    return lineChartOptions;
  }

  mounted() {

    if (this.ServiceId != null) {

      this.getData();
    }
  }

  private async getData() {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/Rankings`, {
        params: { serviceId: this.ServiceId }
      });

      this.rankings = response.data;

    } catch (err) {

      this.error = !this.error;
    }
  }

  private selectKeyword(index: number) {

    this.selectedKeyword = index;
  }

  @Watch('ServiceId')
  private loadDomain (next: number, prev: number) {

    if (next != prev) {

      this.rankings = null;
      this.getData();
    }
  }
}